import React from 'react';
import Select from 'components/Select';
import { IOption } from 'components/Select/Select';
import messages from './Messages';
import Button from '../Button/Button';
import notify from '../Notify';
import { IReportView, ISurveyViewWithData } from 'store/survey/surveyTypes';
import i18n from '../../i18n';

interface IDispatchProps {}

interface IOwnProps {
  survey: ISurveyViewWithData;
  onGenerateReport: (
    questionId: number | undefined,
    options: any
  ) => Promise<any>;
}

type IComponentProps = IOwnProps & IDispatchProps;
interface IComponentStates {
  generating: boolean;
  selectedQuestionId?: number;
}

class ReportAutoGenerate extends React.PureComponent<
  IComponentProps,
  IComponentStates
> {
  state = {
    generating: false,
    selectedQuestionId: undefined,
  };
  handleSelectQuestion = (values: IOption[]) => {
    this.setState({
      selectedQuestionId: Number(
        values[0].value === 'null' ? null : values[0].value
      ),
    });
  };
  handleSave = () => {
    this.props.onGenerateReport(this.state.selectedQuestionId, {}).then(
      (data: IReportView[]) => {
        notify(
          messages.reportsGenerated(data.length),
          'successful',
          true,
          10000
        );
      },
      (error) => {
        notify(error.message, 'error');
      }
    );
  };

  render() {
    const { generating, selectedQuestionId } = this.state;
    const { survey } = this.props;
    // const allSurveyOption = { label: 'کل پرسشنامه', value: 'null' };
    const availableQuestions = Object.values(survey.data.questionMap!).reduce(
      (list: IOption[], question) => {
        if (question.data.deleted) return list;
        if (question.data.type === 'indicator') {
          const option: IOption = {
            value: question.data.id.toString(),
            label: question.data.title,
          };
          list.push(option);
        }
        return list;
      },
      [
        /*allSurveyOption*/
      ] as IOption[]
    );
    return (
      <div>
        <Select
          onChangeValues={this.handleSelectQuestion}
          options={availableQuestions}
          values={availableQuestions.filter(
            (it: IOption) => it.value === String(selectedQuestionId)
          )}
          isRequired={true}
          allowRemove={false}
          label={i18n.t('defaultViewType', { ns: 'survey' }) as string}
        />
        <Button
          color="green"
          onClick={this.handleSave}
          loading={generating}
          disabled={!this.state.selectedQuestionId}
        >
          {i18n.t('generate', { ns: 'survey' }) as string}
        </Button>
      </div>
    );
  }
}

export default ReportAutoGenerate;
